<template>
  <div class="w-100 app">
    <Sidebar />

    <div class="w-100">
      <Header />
      <main class="p-3 bg-home-main">
        <div class="main-div">
          <div class="bg-white">
            <div class="current-balance bg-gray-50">
              <div>
                <div class="mb-4">
                  <h5 class="" style="font-size: 14px">Current Balance</h5>
                  <h6
                    class="font-bold"
                    style="font-size: 22px; font-weight: bold"
                  >
                    {{ formattedBalance }}
                  </h6>
                </div>
                <div class="mb-4">
                  <h5 class="" style="font-size: 14px">Old Balance</h5>
                  <h6
                    class="font-bold"
                    style="font-size: 22px; font-weight: bold"
                  >
                    {{ formattedOldBalance }}
                  </h6>
                </div>
              </div>

              <div class="d-flex">
                <button
                  class="btn btn1 d-flex mr-2"
                  style="align-items: center"
                >
                  <span class="material-icons" style="font-size: 14px"
                    >download</span
                  >
                  <span>Download Statement</span>
                </button>
                <button
                  class="btn btn2 d-flex mr-2"
                  style="align-items: center"
                  @click="showModal = true"
                >
                  <span class="material-icons" style="font-size: 14px"
                    >add</span
                  >
                  <span>Add money</span>
                </button>
              </div>
            </div>

            <!-- SMS Credit Section -->
            <!-- <div class="py-10" style="margin: 20px">
              <div class="">
                <div class="">
                  <span class="text-gray-800"
                    >SMS Credit Balance: ₦ 200,000</span
                  >
                </div>
                <p class="text-sm text-gray-600">
                  This is the remaining balance from your purchased SMS credits
                </p>
              </div>

              <div class="w-full bg-gray-200 rounded-full h-2 mb-4">
                <div class="bg-green-600 h-2 rounded-full w-3/4"></div>
              </div>

              <div class="text-sm text-gray-800">
                Credit Spent: ₦ 2,000 | Credit Balance: ₦ 200,000
              </div>
            </div> -->
          </div>
          <!-- Add Money Modal -->
          <Transition name="fade">
            <div
              v-if="showModal"
              class="modal-overlay"
              @click.self="showModal = false"
            >
              <div class="modal-container">
                <div class="modal-content">
                  <div class="modal-header">
                    <h3 class="modal-title">Add Money</h3>
                    <button @click="showModal = false" class="modal-close">
                      <span class="material-icons">close</span>
                    </button>
                  </div>

                  <!-- Amount input -->
                  <div
                    class="modal-body"
                    v-if="user?.canUpdateBilling === true"
                  >
                    <label for="amount" class="amount-label">Amount (₦)</label>
                    <input
                      type="number"
                      id="amount"
                      v-model="amount"
                      class="amount-input"
                      placeholder="Enter amount"
                    />
                  </div>

                  <!-- Account details  -->
                  <div
                    class="modal-body"
                    v-if="user?.canUpdateBilling !== true"
                  >
                    <label for="account-info" class="account-info-label"
                      >Account Information</label
                    >
                    <div id="account-info" class="account-info">
                      <p><strong>Account Name:</strong> Thinkhat firm</p>
                      <p><strong>Account Number:</strong> N/A</p>
                      <p><strong>Bank:</strong> N/A</p>
                      <p><strong>Narration:</strong> INEC SANS Topup</p>
                    </div>
                    <button @click="copyAccountDetails" class="btn-copy">
                      <span class="material-icons" style="font-size: 16px"
                        >content_copy</span
                      >
                      <span>{{ copyButtonText }}</span>
                    </button>
                  </div>

                  <div class="modal-footer">
                    <button @click="showModal = false" class="btn btn1">
                      Cancel
                    </button>
                    <button
                      v-if="user?.canUpdateBilling === true"
                      @click="submitAmount"
                      class="btn btn2"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>

          <!-- Transactions Section -->
          <div style="padding: 0 35px; flex: 1">
            <h3 class="text-sm font-semibold my-4">Recent Transactions</h3>
            <div class="flex items-center space-x-2">
              <label for="status-filter" class="text-sm text-gray-600 mb-4"
                >Status:</label
              >
              <select
                id="status-filter"
                v-model="selectedStatus"
                @change="fetchTransactions"
                class="px-4 py-2 border rounded-lg text-gray-700 focus:outline-none focus:border-green-500 bg-white"
              >
                <option value="success">Successful</option>
                <option value="failed">Failed</option>
              </select>
            </div>
            <div class="bg-white rounded-lg table-container">
              <table class="table" v-if="loading === false">
                <thead class="bg-gray-50">
                  <tr>
                    <!-- <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      User
                    </th> -->
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Amount
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Type
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Transaction reference
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"
                    >
                      Date & Time
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 t-body">
                  <tr
                    v-for="transaction in transactions"
                    :key="transaction.ref"
                  >
                    <!-- <td class="">
                      <div>{{ transaction.user }}</div>
                      <div class="" style="font-size: 9px; color: #9ea8b7">
                        {{ transaction.bank }}
                      </div>
                    </td> -->
                    <td class="">₦{{ transaction.amount }}</td>
                    <td
                      :style="{
                        color:
                          transaction?.transactionType === 'credit'
                            ? 'green'
                            : transaction?.transactionType === 'debit'
                            ? 'red'
                            : 'inherit',
                      }"
                    >
                      {{ transaction?.transactionType }}
                    </td>
                    <td class="">
                      <div class="text-sm text-gray-900">
                        {{ transaction?.transactionSource?.toLowerCase() }}
                      </div>
                      <!-- <div class="" style="font-size: 9px; color: #9ea8b7">
                        {{ transaction.transactionId }}
                      </div> -->
                    </td>
                    <td class="">
                      {{ formatDate(transaction.createdAt) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                style="
                  width: 100%;
                  margin-top: 20px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
                v-else
              >
                <Loader />
              </div>
            </div>
            <!-- <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li
                  class="page-item"
                  @click="previousPage"
                  :class="hasPrevPage ? 'active' : null"
                  :aria-disabled="hasPrevPage == false ? false : true"
                >
                  <a
                    class="page-link"
                    href="javascript:void()"
                    aria-label="Previous"
                    :style="{
                      cursor: page <= 1 ? 'not-allowed' : 'pointer',
                    }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>

                <li
                  class="page-item"
                  @click="nextPage"
                  :class="hasNextPage ? 'active' : null"
                  :aria-disabled="!hasNextPage ? false : true"
                >
                  <a
                    class="page-link"
                    href="javascript:void()"
                    aria-label="Next"
                    :style="{
                      cursor: !hasNextPage ? 'not-allowed' : 'pointer',
                    }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav> -->
            <div
              style="
                width: 100%;
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <span
                >{{ page }}- {{ parseInt(totalPage / 20) + 1 }} of
                {{ totalpage }}</span
              >
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li
                    class="page-item"
                    @click="previousPage"
                    :class="hasPrevPage ? 'active' : null"
                    :aria-disabled="hasPrevPage == false ? false : true"
                  >
                    <a
                      class="page-link"
                      href="javascript:void()"
                      aria-label="Previous"
                      :style="{
                        cursor: page <= 1 ? 'not-allowed' : 'pointer',
                      }"
                    >
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>

                  <li
                    class="page-item"
                    @click="nextPage"
                    :class="hasNextPage ? 'active' : null"
                    :aria-disabled="!hasNextPage ? false : true"
                  >
                    <a
                      class="page-link"
                      href="javascript:void()"
                      aria-label="Next"
                      :style="{
                        cursor: !hasNextPage ? 'not-allowed' : 'pointer',
                      }"
                    >
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
              <div class="d-flex" style="align-items: center">
                <label
                  style="font-size: 13px; font-weight: 500; margin-right: 10px"
                  >Rows per page</label
                >
                <select v-model="eachPage" @change="setEachPage(eachPage)">
                  <option value="5">5</option>
                  <option value="10">10</option>

                  <option value="15">15</option>
                  <option value="20">20</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- Help Center -->
        <!-- <div class="help-center mt-8 bg-white rounded-lg p-6">
          <h3 class="font-semibold mb-2" style="font-size: 18px">
            Help Center
          </h3>
          <div class="space-y-4">
            <div v-for="(item, index) in helpItems" :key="index">
              <div class="d-flex help-section" @click="toggleHelpItem(index)">
                <span class="" style="color: #607087; font-size: 16px">{{
                  item.question
                }}</span>
                <span
                  class="material-icons"
                  style="color: #607087"
                  :class="{ 'rotate-45 transform': item.expanded }"
                >
                  add
                </span>
              </div>
              <div v-if="item.expanded" class="p-2">
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div> -->
      </main>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Loader from "@/components/loader.vue";
import Sidebar from "@/components/sidebar.vue";
import axios from "axios";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  name: "TransactionDashboard",
  components: {
    Header,
    Sidebar,
    Loader,
  },
  data() {
    return {
      transactions: [
        {
          user: "Madeenah Abdulsalam",
          bank: "Fidelity Bank",
          amount: "760,000",
          transactionType: "Credit",
          dateTime: "23 Jul 2021 | 23:09",
          ref: "Ref320949509509606",
          description: "Madeenah Abdulsalam | Fidelity Bank",
        },
      ],
      wallet: {},
      helpItems: [
        {
          question: "What are SMS credits?",
          answer: "SMS credits allow you to send messages.",
          expanded: false,
        },
        {
          question: "How will I pay?",
          answer: "You can pay through bank transfer or credit card.",
          expanded: false,
        },
        {
          question: "What to do if payment fails?",
          answer: "Check your network and try again or contact support.",
          expanded: false,
        },
      ],
      selectedStatus: "success",
      showModal: false,
      amount: null,
      hasNextPage: false,
      page: 1,
      hasPrevPage: false,
      eachPage: 10,
      totalPage: 0,
      perPage: 0,
      loading: false,
      copyButtonText: "Copy Details",
    };
  },
  methods: {
    toggleHelpItem(index) {
      this.helpItems = this.helpItems.map((item, i) => ({
        ...item,
        expanded: i === index ? !item.expanded : false,
      }));
    },
    formatDate(date) {
      return dayjs(date).format("DD/MM/YYYY HH:mm");
    },
    async fetchTransactions() {
      this.loading = true;
      try {
        const response = await axios.get(
          "v1/admin/transactions?transactionStatus=success",
        );

        this.transactions = response.data.result?.data?.data;
        this.totalPage = response.data.result.data.totalPages;
        this.perPage = response.data.result.data.perPage;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchWallet() {
      try {
        const response = await axios.get("v1/admin/wallet");

        this.wallet = response.data.result.data;
      } catch (error) {
        console.error(error);
      }
    },
    async submitAmount() {
      if (this.amount && this.amount > 0) {
        try {
          const response = await axios.post("v1/admin/fund_wallet", {
            amount: this.amount,
          });
          console.log(response);
          this.showModal = false;
          this.fetchWallet();
          this.fetchTransactions();
        } catch (error) {
          console.error(error);
        }
      } else {
        alert("Please enter a valid amount.");
      }
    },
    async copyAccountDetails() {
      const accountDetails = `
Account Name: Thinkhat Technologies Limited
Account Number: 3011506442
Bank: GTBank
Narration: INEC SANS Topup
  `.trim();

      try {
        await navigator.clipboard.writeText(accountDetails);
        this.copyButtonText = "Copied!";
        setTimeout(() => {
          this.copyButtonText = "Copy Details";
        }, 2000);
      } catch (error) {
        console.error("Copy failed:", error);
        alert("Unable to copy. Please copy manually.");
      }
    },

    async previousPage() {
      if (this.page >= 1) {
        this.page--;

        try {
          let response = await axios.get(
            `v1/admin/transactions?transactionStatus=${this.selectedStatus}&isPaginate=true&limit=${this.eachPage}&page=${this.page}`,
          );
          console.log(response, "response");
          this.transactions = response.data.result.data.data;
          this.totalPage = response.data.result.data.totalPages;
          this.perPage = response.data.result.data.perPage;
        } catch (e) {
          console.log(e);
        }
      }
    },
    async nextPage() {
      console.log(this.transactions);
      console.log(this.page);
      console.log(this.totalPage / 10);
      if (this.page < this.totalPage) {
        this.page++;
        console.log(this.page, "page");

        try {
          let response = await axios.get(
            `v1/admin/transactions?transactionStatus=${this.selectedStatus}&isPaginate=true&limit=${this.eachPage}&page=${this.page}`,
          );
          this.transactions = response.data.result.data.data;
          this.totalPage = response.data.result.data.totalPages;
          this.perPage = response.data.result.data.perPage;
        } catch (e) {
          console.log(e);
        }
      }
    },

    setEachPage(id) {
      this.eachPage = id;
    },
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),

    formattedBalance() {
      return (this.wallet.balance / 1).toLocaleString("en-NG", {
        style: "currency",
        currency: "NGN",
      });
    },
    formattedOldBalance() {
      return (this.wallet.oldBalance / 1).toLocaleString("en-NG", {
        style: "currency",
        currency: "NGN",
      });
    },
  },

  mounted() {
    this.fetchWallet();
    this.fetchTransactions();
  },
};
</script>

<style scoped>
.dashboard {
  font-family: system-ui, -apple-system, sans-serif;
}

.bg-home-main {
  background: #f5f6f7;
  min-height: calc(100vh - 50px);
  overflow: auto;
  position: relative;
  /* gap: 2rem; */
}
.main-div {
  flex: 2;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 0;
}
.current-balance {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
  padding: 16px;
  background-color: #f4f6f9;
}
.help-center {
  flex: 0.7;
  padding: 10px;
}

.transform {
  transition: transform 0.2s ease-in-out;
}
.material-icons {
  font-size: 20px;
  line-height: 1;
}
.btn1 {
  border: 2px solid #fff;
  color: #607087;
  font-size: 12px;
  background: #fff;
  padding: 4px 7px 4px 7px !important;
  font-weight: 500;
  outline: none !important;
  margin-left: 5px;
}
.btn2 {
  border: 2px solid #238f53;
  color: #fff;
  font-size: 12px;
  background: #238f53;
  padding: 4px 7px 4px 7px !important;
  font-weight: 500;
  outline: none !important;
  margin-left: 5px;
}

table {
  border-collapse: separate;
  border-spacing: 0;
  height: 10vh;
  overflow-y: auto;
}

th {
  font-weight: 500;
  background-color: #f9fafb;
}

tr:hover {
  background-color: #f9fafb;
}

.help-section {
  justify-content: space-between;
}
.table-container {
  height: 75%;
  overflow-y: auto;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-content {
  padding: 20px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding-bottom: 16px; */
  padding: 1rem 0rem;
  border-bottom: 1px solid #e5e7eb;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
}

.modal-close:hover {
  color: #4b5563;
}

.modal-body {
  padding: 16px 0;
}

.amount-label,
.account-info-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.amount-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.amount-input:focus {
  border-color: #238f53;
  box-shadow: 0 0 0 2px rgba(35, 143, 83, 0.1);
}

.account-info {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 12px;
}

.account-info p {
  margin: 8px 0;
  color: #374151;
  font-size: 0.875rem;
}

.account-info p:first-child {
  margin-top: 0;
}

.account-info p:last-child {
  margin-bottom: 0;
}

.btn-copy {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 8px 12px;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #374151;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  justify-content: center;
}

.btn-copy:hover {
  background-color: #e5e7eb;
  border-color: #9ca3af;
}

.btn-copy:active {
  transform: scale(0.98);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}
select {
  font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.t-body {
  width: 100%;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
